import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InvoiceStatusForm, {
  InvoiceStatusFormFields,
} from '../../components/InvoiceStatus/InvoiceStatusForm';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';

export default function InvoiceStatusesNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: InvoiceStatusFormFields) => {
    try {
      await api.post(`organizations/${organization.id}/invoice-statuses`, data);

      navigate('/invoice-statuses');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const [formFields, setFormFields] = useState<InvoiceStatusFormFields>(
    {} as InvoiceStatusFormFields
  );

  return (
    <InvoiceStatusForm
      isLoading={1 + 1 === 1}
      title='Nova Situação de OS'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
